module.exports = __webpack_public_path__ + "img/mastercard.28da7dd.png";